import { BaseBus } from "./BaseBus";

export class EquipBoardData extends BaseBus {
    constructor(data: EquipBoardData = null) {
        super(data);
    }
    //contractPM;
    //contractPMId;
    contractNumber;
    contractId;
    //jobPM;
    jobNumber;
    jobId;
    dispatchReason;
    contractDivisionId;
    divisionName;
    //contractJrProjAdminId;
    //jPMName;
    //foremanId;
    //jobForemanName;
    //coordinatorId;
    //coordinatorName;
    jobClassId;
    jobClassName;
    dispatchStatusId;
    dispatchStatusName;
    //tandM;
    //tAndMProfitPerc;
    //lastConfirmDt;
    customerName;
    customerId;
    locationName;
    locationId;
    //estimatedBeginDate;
    //estimatedEndDate;
    finalBillingDt;
    //jobTotal;
    relatedJobType;
    relatedJobTypeId;
    dateExecuted;
    locked;
    caTotal;
    recDate;
    recSaleAmount;
    recCostAmount;
    jobCost;
    invoiceSale;
    bidSale;
    bidCost;
    //bidHrs;
    //actHrs;
    //otherColumnsNeeded;
    //ogJobCost;
    //ogBidSale;
    //ogBidCost;
    get bidProfit() { return this.bidSale - this.bidCost };
    get bidProfitPerc() { return this.bidProfit / this.bidSale };
    get grossProfit() { return this.invoiceSale - this.jobCost };
    get grossProfitPerc() { return this.grossProfit / this.invoiceSale };
    get recGrossProfit() { return this.recSaleAmount - this.recCostAmount };
    get recGrossProfitPerc() { return this.recGrossProfit / this.recSaleAmount };

    //get custLocation() { return this.customerName + ' - ' + this.locationName };
    //get profit() { return this.bidSale - this.jobCost };
    //get percComplete() {
    //    if (this.bidSale != null && this.bidSale > 0) {
    //        return this.profit / this.bidSale
    //    } else { return 0 }
    //};
    //get origEstProfit() { return this.ogBidSale - this.ogBidCost };
    //get percOrigEstProfit() {
    //    if (this.ogBidSale != null && this.ogBidSale > 0) {
    //        return this.origEstProfit / this.ogBidSale
    //    } else { return 0 }
    //};
    //get budgetRemaining() { return ((this.bidCost - this.jobCost) + this.caTotal); };
    //get adjCost() { return this.bidCost + this.caTotal; };
    //get adjEstProfit() { return this.ogBidSale - (this.ogBidCost + this.caTotal); };
    //get adjEstProfitPerc() {
    //    if (this.ogBidSale != null && this.ogBidSale > 0) {
    //        return (this.ogBidSale - (this.ogBidCost + this.caTotal)) / this.ogBidSale;
    //    } else { return 0 }
    //};

}
